var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7879684661673670599(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.25,
    y1: 32,
    x2: 60.75,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bb4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2191e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007edb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33",
    "data-name": "Layer 33"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 32,
    r: 28.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.18,15.82a4.7,4.7,0,0,0-6.67,0L37,20.38h0L28.29,29a.67.67,0,0,0-.16.25h0l-3.61,9.22a.74.74,0,0,0,.17.8.71.71,0,0,0,.53.22.86.86,0,0,0,.27-.05l9.22-3.61h0a.67.67,0,0,0,.25-.16l8.66-8.66h0l4.56-4.56a4.7,4.7,0,0,0,0-6.67Zm-5.09,9.64-4.55-4.55,1.1-1.1,4.55,4.55Zm-8.66,8.66-4.55-4.55,7.6-7.6L42,26.52ZM29.1,30.91l4,4-6.55,2.56Zm18-9.48L45.25,23.3,40.7,18.75l1.87-1.87a3.22,3.22,0,0,1,4.55,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.51,33.15a.75.75,0,0,0-.75.75V48.07H15.93V20.24H30.1a.75.75,0,0,0,0-1.5H15.18a.75.75,0,0,0-.75.75V48.82a.76.76,0,0,0,.75.75H44.51a.75.75,0,0,0,.75-.75V33.9A.74.74,0,0,0,44.51,33.15Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7879684661673670599);
export default __webpack_public_path__ + "static/media/7879684661673670599.51686af8dafef7ae0d8412f200ee1cbe.svg";
export { ForwardRef as ReactComponent };